import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from 'react-router-dom';
// import { I18nextProvider } from 'react-i18next'
import { registerAllModules } from 'handsontable/registry';
// import i18n from '@libs/@core/constants/i18n'
import routes from '@src/routes';
import './handsontable.css';
import './ht-theme-main.css';
registerAllModules();
function App() {
    return _jsx(RouterProvider, { router: routes });
}
export default App;
